export default "__VITE_ASSET__6d27df8e__"